/**
 * Booking Detail Modal Shell
 *
 * Charter: documentation/cursor/Charters/CodeAuditor.md v1.0.1
 *
 * Purpose:
 *   Presentational shell/layout wrapper for the Booking Detail Modal. Renders either the
 *   desktop path (backdrop + centered modal container) or the mobile path (BottomSheet
 *   wrapping content). Does not include tooltip portal—caller retains createPortal and target.
 *
 * Assumptions:
 *   - All behavior (onClose, onBackdropClick, disableDrag, etc.) is supplied by the parent.
 *   - Desktop wrapper is portaled by the parent via createPortal(..., document.body).
 *   - No hooks, effects, or API calls. Pure presentational only.
 *
 * Dependencies:
 *   - Internal: BottomSheet (mobile path only). Receives styles and all props from parent.
 *
 * Version: 1.0.0
 *
 * Changelog:
 *   2026-01-27 Phase 6c: extracted from BookingDetailModal.jsx; desktop and mobile shell JSX moved verbatim.
 */

import BottomSheet from '../BottomSheet.jsx';

function BookingDetailModalShell({
  isOpen,
  isMobile,
  onClose,
  onBackdropClick,
  theme,
  styles,
  children,
  accentColor,
  disableDrag,
}) {
  if (isMobile) {
    return (
      <BottomSheet isOpen={isOpen} onClose={onClose} disableDrag={disableDrag}>
        <div style={{ ...styles.modal, backgroundColor: theme === 'dark' ? 'var(--color-bg-secondary-dark)' : 'var(--color-bg-primary)' }}>
          {children}
        </div>
      </BottomSheet>
    );
  }

  // Desktop: backdrop + centered modal container (parent will createPortal(..., document.body))
  return (
    <div
      style={styles.backdrop}
      onClick={onBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        style={{
          ...styles.modal,
          backgroundColor: theme === 'dark' ? 'var(--color-bg-primary-dark)' : 'var(--color-bg-primary)',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          ...(accentColor ? { borderLeft: `3px solid ${accentColor}` } : {}), // Channel-based accent (3px, 10% alpha)
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export default BookingDetailModalShell;
